import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { runFireworks } from "../../utils/canvas";
import newRequest from "../../utils/newRequest";
import "./Success.scss";

const Success = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);
  const payment_intent = params.get("payment_intent");

  //runFireWorks

  useEffect(() => {
    runFireworks();
  }, []);

  useEffect(() => {
    const makeRequest = async () => {
      try {
        await newRequest.put("/orders", { payment_intent });
        setTimeout(() => {
          navigate("/ordres");
        }, 6000);
      } catch (err) {
        console.log(err);
      }
    };

    makeRequest();
  }, [payment_intent]);

  return (
    <div className="success">
      <div className="success-container">
        <h1>Thank you for your order</h1>
        <p>
          Payment successful. You are being redirected to the orders page. 
          ⚠ Please do not close the page.
        </p>
        <p>
          If you have any questions, please contact
          <a href="mailto:mahmoudayed@hotmail.fr">mahmoudayed@hotmail.fr</a>
        </p>
      </div>
    </div>
  );
};

export default Success;
